ScoreTrekBattle.Settings = ScoreTrekBattle.Settings || {};
ScoreTrekBattle.Settings.League = ScoreTrekBattle.Settings.League || {};

ScoreTrekBattle.Settings.League.Editor = (function() {
    var _this, STATUS, CONFIG;

    CONFIG = {
        VIEW_ID: '/settings/league',
        DEFAULT_TAB: 'seasons',
        SEASON_STORAGE_KEY: 'ScoreTrekBattle.League.Matchday.Season',
        SCOPE_STORAGE_KEY: 'ScoreTrekBattle.Settings.League.Scope',

        TABS: {
            regions: {
                type: 'region',
                scope: [],
                required: []
            },
            countries: {
                type: 'country',
                scope: [],
                required: []
            },
            seasons: {
                type: 'season',
                scope: [],
                required: []
            },
            federations: {
                type: 'federation',
                scope: ['seasonId', 'countryId'],
                required: ['seasonId']
            },
            divisions: {
                type: 'division',
                scope: ['seasonId'],
                required: ['seasonId']
            },
            leagues: {
                type: 'league',
                scope: ['seasonId', 'federationId'],
                required: ['seasonId', 'federationId']
            },
            groups: {
                type: 'group',
                scope: ['seasonId', 'federationId', 'leagueId'],
                required: ['seasonId', 'federationId', 'leagueId']
            },
            preset: {
                type: 'preset',
                scope: ['seasonId', 'federationId', 'leagueId'],
                required: ['seasonId', 'federationId', 'leagueId']
            }
        },

        FIELDS: {
            region: ['id', 'isVisible'],
            country: ['id', 'regionId', 'isVisible'],
            season: ['id', 'name', 'startYear', 'endYear', 'isCurrent', 'isVisible'],
            federation: ['id', 'countryId', 'parentId', 'name', 'shortName', 'logo', 'isVisible'],
            division: ['id', 'sortOrder', 'isVisible'],
            league: ['id', 'slug', 'federationId', 'divisionId', 'name', 'level', 'sortOrder', 'isVisible'],
            group: ['id', 'slug', 'leagueId', 'name', 'sortOrder', 'isVisible']
        },

        NUMBER_FIELDS: ['sortOrder', 'startYear', 'endYear', 'level'],

        BOOLEAN_FIELDS: ['isCurrent', 'isVisible'],

        SCOPE_DEFAULTS: {
            federation: {countryId: 'countryId'},
            league: {federationId: 'federationId'},
            group: {leagueId: 'leagueId'}
        }
    };

    function resetStatus() {
        STATUS = {
            active: false,
            view: null,
            $view: null,
            $list: null,
            $preset: null,
            tab: CONFIG.DEFAULT_TAB,
            listRequestId: 0,
            options: null,
            flags: null,
            scope: {
                seasonId: '',
                countryId: '',
                federationId: '',
                leagueId: ''
            }
        };
    }
    resetStatus();

    function onViewRender(tab, refId) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu('/settings');

            ScoreTrekBattle.Template.render('settings/league/editor').then(view => {
                STATUS.active = true;
                STATUS.view = view;
                STATUS.$view = view.$view;
                STATUS.$list = view.$view.find('[data-id="list"]');
                STATUS.$preset = view.$view.find('[data-id="preset"]');

                restoreScope();
                initScopeControls();

                resolve(view.$view);
            });
        });
    }

    function onViewLoad(tab, refId) {
        return new Promise(function(resolve) {
            STATUS.active = true;

            loadOptions().then(() => {
                applyTab(tab, refId);
                resolve();
            });
        });
    }

    function onViewUpdate(tab, refId) {
        return new Promise(function(resolve) {
            if (!STATUS.active) {
                resolve();
                return;
            }

            applyTab(tab, refId);
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Settings.League.Preset.close();
            resetStatus();
            resolve();
        });
    }

    function applyTab(tab, refId) {
        var tabConfig;

        tab = String(tab || '').trim();

        if (!CONFIG.TABS.hasOwnProperty(tab)) {
            tab = CONFIG.DEFAULT_TAB;
        }

        if ((tab === 'preset') && refId) {
            STATUS.scope.leagueId = refId;
            alignFederationToLeague(refId);
        }

        STATUS.tab = tab;
        tabConfig = CONFIG.TABS[tab];

        STATUS.$view.find('[data-tab]').removeClass('isActive');
        STATUS.$view.find(`[data-tab="${tab}"]`).addClass('isActive');

        STATUS.$view.find('[data-id="titleIcon"]').attr('class', STATUS.$view.find(`[data-tab="${tab}"] i`).attr('class'));
        STATUS.$view.find('[data-id="titleText"]').text(__i18n(`league/editor/tabs/${tab}`));

        STATUS.$view.find('[data-scope]').each(function() {
            $(this).toggle(tabConfig.scope.indexOf(this.dataset.scope) >= 0);
        });

        STATUS.$view.find('[data-id="addButtonLabel"]').text(__i18n(`league/editor/add/${tabConfig.type}`));

        refreshScopeControls();
        update();
    }

    function alignFederationToLeague(leagueId) {
        var league;

        league = findOption('leagues', leagueId);

        if (league) {
            STATUS.scope.federationId = league.federationId;
        }
    }

    function findOption(collection, id) {
        var list, found;

        list = (STATUS.options && STATUS.options[collection]) ? STATUS.options[collection] : [];
        found = null;

        list.forEach(entry => {
            if (entry.id === id) {
                found = entry;
            }
        });

        return found;
    }

    function restoreScope() {
        var stored;

        stored = chmStorage.getSession(CONFIG.SCOPE_STORAGE_KEY);

        if (stored && (typeof stored === 'object')) {
            Object.keys(STATUS.scope).forEach(key => {
                STATUS.scope[key] = String(stored[key] || '');
            });
        }

        if (STATUS.scope.seasonId === '') {
            STATUS.scope.seasonId = localStorage.getItem(CONFIG.SEASON_STORAGE_KEY) || '';
        }
    }

    function storeScope() {
        chmStorage.setSession(CONFIG.SCOPE_STORAGE_KEY, STATUS.scope);

        if (STATUS.scope.seasonId !== '') {
            localStorage.setItem(CONFIG.SEASON_STORAGE_KEY, STATUS.scope.seasonId);
        }
    }

    function initScopeControls() {
        Object.keys(STATUS.scope).forEach(key => {
            var control;

            control = STATUS.view.controls[key];

            if (!control) {
                return;
            }

            control.on('change', function() {
                STATUS.scope[key] = this.get();

                if (key === 'seasonId') {
                    STATUS.scope.federationId = '';
                    STATUS.scope.leagueId = '';
                    storeScope();
                    loadOptions().then(() => {
                        refreshScopeControls();
                        update();
                    });
                    return;
                }

                if (key === 'federationId') {
                    STATUS.scope.leagueId = '';
                }

                storeScope();
                refreshScopeControls();
                update();
            });
        });
    }

    function fallbackId() {
        return (STATUS.options && STATUS.options.fallbackId) ? STATUS.options.fallbackId : '';
    }

    function isFallbackSelected() {
        return ((STATUS.tab === 'preset') && (STATUS.scope.leagueId !== '') && (STATUS.scope.leagueId === fallbackId()));
    }

    function refreshScopeControls() {
        var controls, options, current, before;

        if (!STATUS.options) {
            return;
        }

        controls = STATUS.view.controls;

        controls.seasonId.setOptions(buildSeasonOptions());
        controls.seasonId.set(STATUS.scope.seasonId);
        STATUS.scope.seasonId = controls.seasonId.get() || '';

        controls.countryId.setOptions(buildIconOptions(STATUS.options.countries, 'flagUrl'), {'': `-- ${__i18n('filter/all')} --`});
        controls.countryId.set(STATUS.scope.countryId);
        STATUS.scope.countryId = controls.countryId.get() || '';

        controls.federationId.setOptions(buildFederationOptions(), {'': `-- ${__i18n('filter/pleaseSelect')} --`});
        controls.federationId.set(STATUS.scope.federationId);
        STATUS.scope.federationId = controls.federationId.get() || '';

        options = buildLeagueOptions(STATUS.scope.federationId);
        current = STATUS.scope.leagueId;

        before = {'': `-- ${__i18n('filter/pleaseSelect')} --`};

        if (STATUS.tab === 'preset') {
            before[fallbackId()] = __i18n('league/editor/preset/fallbackOption');
        }

        controls.leagueId.setOptions(options, before);
        controls.leagueId.set(current);
        STATUS.scope.leagueId = controls.leagueId.get() || '';

        storeScope();
    }

    function resolveSeasonId() {
        var wanted, exists, current, first;

        wanted = STATUS.scope.seasonId;
        exists = false;
        current = '';
        first = '';

        STATUS.options.seasons.forEach(season => {
            if (first === '') {
                first = season.id;
            }

            if (season.isCurrent) {
                current = season.id;
            }

            if (season.id === wanted) {
                exists = true;
            }
        });

        return exists ? wanted : (current || first);
    }

    function buildSeasonOptions() {
        var options;

        options = {};

        STATUS.options.seasons.forEach(season => {
            options[season.id] = season.isCurrent
                ? `${season.name} (${__i18n('league/editor/currentSeason')})`
                : season.name;
        });

        return options;
    }

    function sortByShortName(federations) {
        return federations.slice().sort((federationA, federationB) => {
            var shortA, shortB;

            shortA = federationA.shortName || '';
            shortB = federationB.shortName || '';

            if (shortA === shortB) {
                return 0;
            }

            return (shortA < shortB) ? -1 : 1;
        });
    }

    function buildFederationChildren() {
        var known, children;

        known = {};
        children = {};

        STATUS.options.federations.forEach(federation => {
            known[federation.id] = true;
        });

        STATUS.options.federations.forEach(federation => {
            var parentId;

            parentId = federation.parentId || '';

            if (!known[parentId]) {
                parentId = '';
            }

            if (!children[parentId]) {
                children[parentId] = [];
            }

            children[parentId].push(federation);
        });

        return children;
    }

    function collectFederationOptions(options, parentId, children, depth, excludeId) {
        sortByShortName(children[parentId] || []).forEach(federation => {
            if (federation.id === excludeId) {
                return;
            }

            options[federation.id] = buildIconOption(federation, 'logoUrl', depth);

            collectFederationOptions(options, federation.id, children, depth + 1, excludeId);
        });
    }

    function buildFederationOptions(excludeId) {
        var children, roots, groups, flat;

        excludeId = excludeId || '';

        children = buildFederationChildren();

        roots = sortByShortName(children[''] || []).filter(federation => {
            return (federation.id !== excludeId);
        });

        groups = [];
        flat = {};

        roots.forEach(root => {
            flat[root.id] = buildIconOption(root, 'logoUrl', 0);
        });

        if (Object.keys(flat).length > 0) {
            groups.push({label: '', options: flat});
        }

        roots.forEach(root => {
            var options;

            options = {};

            collectFederationOptions(options, root.id, children, 0, excludeId);

            if (Object.keys(options).length > 0) {
                groups.push({label: root.name, options: options});
            }
        });

        return groups;
    }

    function buildLeagueOptions(federationId) {
        var groups, order, result;

        groups = {};
        order = [];

        STATUS.options.divisions.forEach(division => {
            groups[division.id] = {label: division.name, options: {}};
            order.push(division.id);
        });

        STATUS.options.leagues.forEach(league => {
            if (federationId && (league.federationId !== federationId)) {
                return;
            }

            if (!groups[league.divisionId]) {
                groups[league.divisionId] = {label: divisionName(league.divisionId), options: {}};
                order.push(league.divisionId);
            }

            groups[league.divisionId].options[league.id] = league.name;
        });

        result = [];

        order.forEach(divisionId => {
            if (Object.keys(groups[divisionId].options).length > 0) {
                result.push(groups[divisionId]);
            }
        });

        return result;
    }

    function buildIconOptions(list, iconKey) {
        var options;

        options = {};

        list.forEach(entry => {
            options[entry.id] = buildIconOption(entry, iconKey);
        });

        return options;
    }

    function buildIconOption(entry, iconKey, indent) {
        var icon, shortName, option;

        icon = entry[iconKey] || '';
        shortName = entry.shortName || '';

        option = ((icon === '') && (shortName === ''))
            ? {text: entry.name}
            : {
                text: entry.name,
                $html: ScoreTrekBattle.League.Select.renderItem(entry.name, icon, shortName, (iconKey === 'logoUrl'))
            };

        if (indent) {
            option.indent = indent;
        }

        return option;
    }

    function divisionName(divisionId) {
        var division;

        division = findOption('divisions', divisionId);

        return division ? division.name : divisionId;
    }

    function requestOptions(seasonId) {
        return Api.request('/battle/league/editor/options', {
            seasonId: seasonId
        }).then(result => {
            STATUS.options = result.options;
        });
    }

    function loadOptions() {
        ScoreTrekBattle.View.loading('Settings.League.options', true);

        return requestOptions(STATUS.scope.seasonId).then(() => {
            var seasonId;

            seasonId = resolveSeasonId();

            if (seasonId === STATUS.scope.seasonId) {
                return null;
            }

            STATUS.scope.seasonId = seasonId;

            return (seasonId === '') ? null : requestOptions(seasonId);
        }).catch(error => {
            showError(error);
            STATUS.options = {fallbackId: '', hasFallback: false, regions: [], countries: [], seasons: [], federations: [], divisions: [], leagues: []};
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.League.options', false);
        });
    }

    function loadFlags() {
        if (STATUS.flags !== null) {
            return Promise.resolve(STATUS.flags);
        }

        ScoreTrekBattle.View.loading('Settings.League.flags', true);

        return Api.request('/battle/league/editor/flags').then(result => {
            STATUS.flags = result.list || [];
            return STATUS.flags;
        }).catch(error => {
            showError(error);
            return [];
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.League.flags', false);
        });
    }

    function update() {
        var missing;

        STATUS.$list.empty();
        STATUS.$preset.empty();
        ScoreTrekBattle.Settings.League.Preset.close();

        missing = missingScope();

        showScopeHint(missing);
        STATUS.$view.find('[data-id="addButton"]').toggle((missing === '') && (STATUS.tab !== 'preset'));

        if (missing !== '') {
            return;
        }

        if (STATUS.tab === 'preset') {
            updatePreset();
            return;
        }

        updateList();
    }

    function missingScope() {
        var missing;

        if (isFallbackSelected()) {
            return '';
        }

        missing = '';

        CONFIG.TABS[STATUS.tab].required.forEach(key => {
            if ((missing === '') && (STATUS.scope[key] === '')) {
                missing = key;
            }
        });

        return missing;
    }

    function showScopeHint(missing) {
        var $hint;

        $hint = STATUS.$view.find('[data-id="scopeHint"]');

        if (missing === '') {
            $hint.hide();
            return;
        }

        STATUS.$view.find('[data-id="scopeHintText"]').text(__i18n(`league/editor/choose/${missing}`));
        $hint.show();
    }

    function updatePreset() {
        var isFallback, league;

        isFallback = isFallbackSelected();
        league = isFallback ? null : findOption('leagues', STATUS.scope.leagueId);

        ScoreTrekBattle.Settings.League.Preset.open(
            STATUS.$preset,
            isFallback ? '' : STATUS.scope.seasonId,
            STATUS.scope.leagueId,
            isFallback ? __i18n('league/editor/preset/fallbackName') : (league ? league.name : STATUS.scope.leagueId),
            isFallback
        );
    }

    function updateList() {
        var requestId, request;

        STATUS.listRequestId++;
        requestId = STATUS.listRequestId;

        request = {type: CONFIG.TABS[STATUS.tab].type};

        CONFIG.TABS[STATUS.tab].scope.forEach(key => {
            request[key] = STATUS.scope[key];
        });

        STATUS.$list.addClass('loading');
        ScoreTrekBattle.View.loading('Settings.League.list', true);

        Api.request('/battle/league/editor/list', request).then(result => {
            if (requestId !== STATUS.listRequestId) {
                return;
            }

            renderList(result.list || [], requestId);
        }).catch(error => {
            showError(error);
        }).finally(() => {
            STATUS.$list.removeClass('loading');
            ScoreTrekBattle.View.loading('Settings.League.list', false);
        });
    }

    function renderList(items, requestId) {
        var promises;

        promises = [];

        items.forEach(item => {
            promises.push(renderItem(item, false));
        });

        Promise.all(promises).then($items => {
            if (requestId !== STATUS.listRequestId) {
                return;
            }

            STATUS.$list.empty();

            if ($items.length === 0) {
                STATUS.$list.append(
                    $('<div>').addClass('league-editor-empty').text(__i18n('league/editor/empty'))
                );
                return;
            }

            STATUS.$list.append($items);
        });
    }

    function renderItem(item, isNew) {
        var type;

        type = CONFIG.TABS[STATUS.tab].type;

        return ScoreTrekBattle.Template.render(`settings/league/${type}`, {item: item}, true).then(view => {
            var $element, current;

            current = DataHandler.cloneObject(item);

            $element = {
                view: view.$view,
                title: view.$view.find('[data-id="itemTitle"]'),
                hidden: view.$view.find('[data-id="hidden"]'),
                clubs: view.$view.find('[data-id="clubs"]'),
                usage: view.$view.find('[data-id="usage"]'),
                create: view.$view.find('[data-id="create"]'),
                cancel: view.$view.find('[data-id="cancel"]'),
                saved: view.$view.find('[data-id="saved"]'),
                delete: view.$view.find('[data-id="delete"]'),
                locked: view.$view.find('[data-id="locked"]'),
                lockedCount: view.$view.find('[data-id="lockedCount"]')
            };

            fillControls(type, view, current);

            if (type === 'country') {
                initFlagChoice(view, current, isNew, () => {
                    return persist(type, view, current, $element);
                });
            }

            if (type === 'league') {
                initPresetLink(view, current);
            }

            if (type === 'federation') {
                renderClubList(view.$view, current.clubs);
            }

            $element.saved.hide();
            $element.create.toggle(isNew);
            $element.cancel.toggle(isNew);
            $element.delete.toggle(!isNew && (current.usage === 0));
            $element.clubs.toggle(!isNew);
            $element.locked.toggle(!isNew && (current.usage > 0));
            $element.locked.attr('title', __i18n('error/LEAGUE_ENTITY_IN_USE', {usage: current.usage || 0}));
            $element.lockedCount.text(current.usage || '');

            view.controls.id.disable(!isNew);

            if (isNew) {
                view.controls.id.focus();
            }

            CONFIG.FIELDS[type].forEach(field => {
                if (field === 'id') {
                    return;
                }

                view.controls[field].on('change', function() {
                    if (isNew) {
                        return;
                    }

                    persist(type, view, current, $element);
                });
            });

            $element.create.on('click', function() {
                persist(type, view, current, $element).then(saved => {
                    if (!saved) {
                        return;
                    }

                    isNew = false;
                    current = saved;

                    $element.create.hide();
                    $element.cancel.hide();
                    $element.delete.toggle(saved.usage === 0);
                    view.controls.id.disable(true);

                    if (type === 'league') {
                        initPresetLink(view, current);
                    }

                    $element.view.attr('data-item-id', saved.id);
                    $element.clubs.toggle(type === 'federation');
                });
            });

            $element.cancel.on('click', function() {
                view.$view.slideUp(function() {
                    view.$view.remove();
                });
            });

            $element.delete.on('click', function() {
                confirmDelete(type, current, view.$view);
            });

            updateTitle(type, $element, current);

            return view.$view;
        });
    }

    function fillControls(type, view, item) {
        CONFIG.FIELDS[type].forEach(field => {
            var control;

            control = view.controls[field];

            if (!control) {
                console.warn(`Missing league editor control: ${type}.${field}`);
                return;
            }

            if (field === 'regionId') {
                control.setOptions(buildIconOptions(STATUS.options.regions), {'': `-- ${__i18n('filter/pleaseSelect')} --`});
            } else if (field === 'countryId') {
                control.setOptions(buildIconOptions(STATUS.options.countries, 'flagUrl'), {'': `-- ${__i18n('filter/pleaseSelect')} --`});
            } else if (field === 'divisionId') {
                control.setOptions(buildIconOptions(STATUS.options.divisions), {'': `-- ${__i18n('filter/pleaseSelect')} --`});
            } else if (field === 'federationId') {
                control.setOptions(buildFederationOptions(), {'': `-- ${__i18n('filter/pleaseSelect')} --`});
            } else if (field === 'leagueId') {
                control.setOptions(buildLeagueOptions(STATUS.scope.federationId), {'': `-- ${__i18n('filter/pleaseSelect')} --`});
            } else if (field === 'parentId') {
                control.setOptions(buildFederationOptions(item.id), {'': `-- ${__i18n('league/editor/noParent')} --`});
            }

            control.set(item[field]);
        });
    }

    function initPresetLink(view, item) {
        var $link;

        $link = view.$view.find('[data-id="presetLink"]');

        if (item.id === '') {
            $link.hide();
            return;
        }

        $link.attr('href', `${CONFIG.VIEW_ID}/preset/${encodeURIComponent(item.id)}`);
        $link.find('[data-id="presetLinkText"]').text(
            __i18n(item.hasPreset ? 'league/editor/preset/edit' : 'league/editor/preset/create')
        );
        $link.attr('title', (!item.hasPreset && STATUS.options.hasFallback) ? __i18n('league/editor/hint/fallbackLeague') : '');
        $link.toggleClass('hasPreset', !!item.hasPreset);
        $link.show();
    }

    function renderClubList($item, clubs) {
        clubs = clubs || [];

        return Promise.all(clubs.map(club => {
            return ScoreTrekBattle.Template.render('settings/league/clubItem', {club: club}, true).then(clubView => {
                return clubView.$view;
            });
        })).then($clubs => {
            $item.find('[data-id="clubList"]').empty().append($clubs);
            $item.find('[data-id="clubsEmpty"]').toggle(clubs.length === 0);
        });
    }

    function changeClub(action, federationId, clubId) {
        ScoreTrekBattle.View.loading('Settings.League.clubs', true);

        Api.request(`/battle/league/editor/club/${action}`, {
            seasonId: STATUS.scope.seasonId,
            federationId: federationId,
            clubId: clubId
        }).then(result => {
            renderClubList(STATUS.$list.find(`[data-item-id="${federationId}"]`), result.clubs || []);
        }).catch(error => {
            showError(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.League.clubs', false);
        });
    }

    function chooseClub(assignedIds, onSelect) {
        var items;

        items = (ScoreTrekBattle.CONFIG.clubs || []).filter(club => {
            return (assignedIds.indexOf(club.id) < 0);
        }).map(club => {
            var option;

            option = buildIconOption(club, 'logo');

            return {
                value: club.id,
                html: option.$html || option
            };
        });

        if (items.length === 0) {
            chmDialog.info(__i18n('league/editor/clubs/allAssigned'));
            return;
        }

        chmSelect({
            title: __i18n('league/editor/clubs/add'),
            isSearchable: true,
            items: items,
            onSelect: onSelect
        });
    }

    function initFlagChoice(view, item, isNew, onChange) {
        var $choice;

        $choice = view.$view.find('[data-id="flagChoice"]');

        function apply() {
            var flagUrl;

            flagUrl = item.flagUrl || '';

            view.$view.find('[data-id="flagPreview"]').css('background-image', flagUrl ? `url('${flagUrl}')` : '');
            $choice.find('[data-id="flagChoiceIcon"]').css('background-image', flagUrl ? `url('${flagUrl}')` : '');
            $choice.find('[data-id="flagChoiceName"]').text(item.flag || __i18n('league/editor/flag/none'));
        }

        apply();

        $choice.on('click', function() {
            chooseFlag(item.flag, flag => {
                item.flag = flag.file;
                item.flagUrl = flag.url;
                apply();

                if (!isNew) {
                    onChange();
                }
            });
        });
    }

    function collect(type, view, item) {
        var data;

        data = {};

        CONFIG.FIELDS[type].forEach(field => {
            var value;

            value = view.controls[field].get();

            if (CONFIG.NUMBER_FIELDS.indexOf(field) >= 0) {
                value = parseInt(value, 10) || 0;
            } else if (CONFIG.BOOLEAN_FIELDS.indexOf(field) >= 0) {
                value = !!value;
            } else {
                value = String(value || '').trim();
            }

            data[field] = value;
        });

        if (type === 'country') {
            data.flag = item.flag || '';
        }

        if (['federation', 'division', 'league', 'group'].indexOf(type) >= 0) {
            data.seasonId = STATUS.scope.seasonId;
        }

        return data;
    }

    function persist(type, view, current, $element) {
        var data;

        data = collect(type, view, current);

        if (data.id === '') {
            view.forms.item.errors([{field: 'id', message: __i18n('league/editor/error/missingId')}]);
            return Promise.resolve(null);
        }

        view.forms.item.errors([]);

        ScoreTrekBattle.View.loading('Settings.League.save', true);

        return Api.request('/battle/league/editor/save', {
            type: type,
            item: data
        }).then(result => {
            Object.keys(result.item).forEach(key => {
                current[key] = result.item[key];
            });

            updateTitle(type, $element, current);
            indicateSaved($element);

            if (['season', 'federation', 'division', 'league'].indexOf(type) >= 0) {
                loadOptions().then(refreshScopeControls);
            }

            if ((type === 'season') && data.isCurrent) {
                updateList();
            }

            return current;
        }).catch(error => {
            showError(error);
            return null;
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.League.save', false);
        });
    }

    function indicateSaved($element) {
        $element.saved.stop(true, true).fadeIn(120).delay(1200).fadeOut(400);
    }

    function updateTitle(type, $element, item) {
        var title, shortName;

        title = item.name || item.id || __i18n('league/editor/newEntry');
        shortName = (type === 'federation') ? (item.shortName || '') : '';

        $element.title.text(title);

        if (shortName !== '') {
            $element.title.prepend($('<span>').addClass('league-editor-item-shortname').text(shortName));
        }

        $element.title.toggleClass('isMissingTranslation', (item.hasTranslation === false));

        if (item.hasTranslation === false) {
            $element.title.attr('title', __i18n('league/editor/missingTranslation'));
        } else {
            $element.title.removeAttr('title');
        }

        $element.usage.text(item.usage ? __i18n('league/editor/usage', {count: item.usage}) : '');

        $element.view.toggleClass('isHidden', (item.isVisible === false));
        $element.hidden.toggle(item.isVisible === false);
    }

    function addItem() {
        var type, item;

        type = CONFIG.TABS[STATUS.tab].type;

        item = buildEmptyItem(type);

        renderItem(item, true).then($item => {
            $item.hide();
            STATUS.$list.find('.league-editor-empty').remove();
            STATUS.$list.prepend($item);
            $item.slideDown(function() {
                AnimationHandler.scrollIntoView($item).catch(() => {});
            });
        });
    }

    function buildEmptyItem(type) {
        var item, defaults;

        item = {
            id: '',
            name: '',
            sortOrder: 0,
            isVisible: true,
            usage: 0
        };

        if (type === 'season') {
            item.startYear = new Date().getFullYear();
            item.endYear = (item.startYear + 1);
            item.name = `${item.startYear}/${item.endYear}`;
            item.id = `${item.startYear}-${item.endYear}`;
            item.isCurrent = false;
        }

        if (type === 'country') {
            item.flag = '';
            item.flagUrl = '';
            item.regionId = '';
        }

        if (type === 'federation') {
            item.parentId = '';
            item.shortName = '';
            item.logo = '';
        }

        if (type === 'league') {
            item.slug = '';
            item.divisionId = '';
            item.level = 0;
            item.hasPreset = false;
        }

        if (type === 'group') {
            item.slug = '';
        }

        defaults = CONFIG.SCOPE_DEFAULTS[type] || {};

        Object.keys(defaults).forEach(field => {
            item[field] = STATUS.scope[defaults[field]];
        });

        return item;
    }

    function confirmDelete(type, item, $item) {
        chmDialog.confirm(__i18n('dialog/confirm/delete/text', {
            colorClass: 'color-blue',
            reference: (item.name || item.id)
        }, true), {
            title: __i18n('dialog/confirm/delete/title'),
            buttonYes: __i18n('button/delete'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            ScoreTrekBattle.View.loading('Settings.League.delete', true);

            Api.request('/battle/league/editor/delete', {
                type: type,
                item: {
                    id: item.id,
                    seasonId: item.seasonId || STATUS.scope.seasonId
                }
            }).then(() => {
                $item.slideUp(function() {
                    $item.remove();
                });

                if (['season', 'federation', 'division', 'league'].indexOf(type) >= 0) {
                    loadOptions().then(refreshScopeControls);
                }
            }).catch(error => {
                showError(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Settings.League.delete', false);
            });
        }).catch(ignore => {});
    }

    function chooseFlag(currentFlag, onSelect) {
        loadFlags().then(flags => {
            chmSelect({
                title: __i18n('league/editor/field/flag'),
                isSearchable: true,
                items: [{value: '', html: __i18n('league/editor/flag/none'), isSelected: (currentFlag === '')}].concat(
                    flags.map(flag => {
                        return {
                            value: flag.file,
                            html: buildIconOption(flag, 'url').$html,
                            isSelected: (flag.file === currentFlag)
                        };
                    })
                ),
                onSelect: function(file) {
                    onSelect(flags.filter(flag => flag.file === file)[0] || {file: '', url: ''});
                }
            });
        });
    }

    function showError(error) {
        chmDialog.error(error, (error && error.errorData) ? error.errorData : null);
    }

    _this = {
        getSeasonName: function(seasonId) {
            var season;

            season = findOption('seasons', seasonId);

            return season ? season.name : '';
        },
        showError: function(error) {
            showError(error);
        },
        refresh: function() {
            update();
        }
    };

    ScoreTrekBattle.Event.on('action.leagueEditor.add', function() {
        if (!STATUS.active) {
            return;
        }

        addItem();
    });

    ScoreTrekBattle.Event.on('action.leagueEditor.club.add', function() {
        var $item, assignedIds;

        if (!STATUS.active) {
            return;
        }

        $item = $(this).closest('[data-item-id]');

        assignedIds = $item.find('[data-club-id]').map(function() {
            return this.dataset.clubId;
        }).get();

        chooseClub(assignedIds, clubId => {
            changeClub('assign', $item.attr('data-item-id'), clubId);
        });
    });

    ScoreTrekBattle.Event.on('action.leagueEditor.club.remove', function() {
        var $club;

        if (!STATUS.active) {
            return;
        }

        $club = $(this).closest('[data-club-id]');

        changeClub('unassign', $club.closest('[data-item-id]').attr('data-item-id'), $club.attr('data-club-id'));
    });

    ScoreTrekBattle.View.register(CONFIG.VIEW_ID, onViewRender, onViewLoad, onViewUpdate, onViewUnload, () => {
        return ScoreTrekBattle.Session.isSysAdmin();
    });

    return _this;
})();
